import { IForecastAccuracyRepository } from '../interfaces/IForecastAccuracyRepository';
import {
  GetForecastAccuracyHistoryApi,
  ForecastAccuracyHistoryFromSummaryDataResponse,
  GetForecastAccuracyHistoryFromSummaryDataResult,
} from '../axios/generated/aggregateBusinessManage';
import { customAxiosInstance } from '../axios/axiosInstance';
import { AxiosResponse } from 'axios';
import { axiosErrorHandler } from '../axios/axiosError';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '../interfaces/IError';

/**
 * 内示正答率リポジトリ実装
 * @description 新しいAPIを使用して内示正答率履歴を取得する
 */
export class ForecastAccuracyRepository implements IForecastAccuracyRepository {
  /**
   * 内示正答率履歴取得
   * @param businessId - 取引ID（aggregateBusinessIdとして扱う）
   * @param startYear - 開始年
   * @param startMonth - 開始月
   * @param period - 期間（Nヶ月前内示のN）
   * @returns 内示正答率履歴データ
   */
  async getForecastAccuracyHistory(
    businessId: string,
    startYear: number,
    startMonth: number,
    period: number
  ): Promise<INetworkResult<GetForecastAccuracyHistoryFromSummaryDataResult, IError>> {
    try {
      const axiosInstance = await customAxiosInstance('dbAccess');
      const api = new GetForecastAccuracyHistoryApi(undefined, undefined, axiosInstance);

      // APIを呼び出し（引数で受け取った値をそのまま使用）
      const apiResponse: AxiosResponse<ForecastAccuracyHistoryFromSummaryDataResponse> =
        await api.forecastAccuracyHistoryFromSummaryDataAggregateBusinessIdGet(businessId, startYear, startMonth, period);

      if (apiResponse.status === 200) {
        return {
          status: {
            type: 'success',
            data: apiResponse.data.result,
          },
        };
      } else {
        throw new Error(`Unexpected response status: ${apiResponse.status}`);
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: axiosErrorHandler(error),
        },
      };
    }
  }
}
